import * as React from "react";
import {
  Avatar,
  Box,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import useGlobalStyles from "styles/globalStyles";
import { useAuth } from "context/AuthContext";
import { colors } from "styles/colors";
import CustomText from "components/common/CustomText/CustomText";
import { toTitleCase } from "common/utils";
import ProfileOptions from "../ProfileOptions/ProfileOptions";

export default function ProfileInfoSection() {
  const { user } = useAuth();
  const globalStyles = useGlobalStyles();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        display: "flex",
        justifyContent: "space-between",
      }}
      className={globalStyles.sectionContainer}
    >
      {/* Left section */}
      <Stack direction="row" spacing={3} alignItems="center">
        <Avatar
          src={user?.profile_image?.href_small}
          alt="profile picture"
          sx={{
            width: 117,
            height: 117,
            backgroundColor: colors.avatarBg,
          }}
        />

        <Box>
          {/* User Name */}
          <CustomText
            text={`${user.first_name} ${user.last_name} ${user?.user_role ? `(${toTitleCase(user.user_role.name)}` : ''})`}
            fontSize={25}
            fontWeight={600}
            color={colors.primary}
            lineHeight={1}
          />

          {/* Speciality */}
          <CustomText
            text={user.user_profile[0].speciality?.name}
            fontSize={16}
            color={colors.secondary}
          />

          {/* Email */}
          <Box mt={0.5}>
            <CustomText
              text={user.email}
              fontSize={16}
              color={colors.secondary}
            />
          </Box>

        </Box>
      </Stack>

      {/* Right menu */}
      <Box alignSelf="flex-start">
        <ProfileOptions />
      </Box>
    </Paper>
  );
}
